import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Server-verified protection: three states (null = checking, true, false).
export const AdminGuard = ({ children }) => {
  const [authed, setAuthed] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.user) {
      setAuthed(true);
      return;
    }
    let live = true;
    fetch(`${API}/auth/me`, { credentials: "include" })
      .then((r) => {
        if (!r.ok) throw new Error("not authenticated");
        return r.json();
      })
      .then(() => live && setAuthed(true))
      .catch(() => {
        if (!live) return;
        setAuthed(false);
        navigate("/admin/login", { replace: true });
      });
    return () => {
      live = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (authed === null) {
    return (
      <div
        className="flex min-h-[70vh] items-center justify-center"
        data-testid="admin-loading"
      >
        <p className="text-sm font-semibold text-charcoal/50">Checking access…</p>
      </div>
    );
  }
  if (!authed) return null;
  return children;
};
